/*
  ALTRA — 防水性ファセットを排他選択(ラジオ的)にする
  ==================================================================
  防水 / 非防水 は商品ごとに排他(両立しない)。ネイティブ Storefront filtering は
  同一軸の複数値を checkbox の OR として扱うため、両方選ぶと和集合=全件になり無意味。
  そこで「片方を選んだら同一軸の他値を外してから submit させる」ことで radio 相当にする。

  方式:
  - document への capture-phase 委譲リスナー。facet-filters-form の debounce 付き submit が
    FormData を読む前(=capture)に兄弟値を外すので、生成 URL に他値が乗らない。
  - markup は無改変(facets.liquid を汚さない)。属性 name で防水軸だけを対象にする。
  - 同じ値を再クリックした場合は checkbox が外れる(t.checked === false)ので何もしない
    = 解除(トグル off)。これにより「防水↔非防水の排他切替」と「未選択へ戻す」が両立する。
  - desktop(FacetFiltersForm) と mobile(FacetFiltersFormMobile) の双方に効く(document 委譲)。
  - サーバ再描画でファセット DOM が差し替わってもリスナーは document 上で生存する。
*/
(function () {
  var PARAM = 'filter.p.m.specs.waterproof';

  function onChange(event) {
    var target = event.target;
    if (!target || target.name !== PARAM || target.type !== 'checkbox' || !target.checked) return;

    var form = target.form || (target.closest && target.closest('form'));
    if (!form) return;

    // 同一フォーム内の防水軸の他値を外す(=排他)
    form.querySelectorAll('input[name="' + PARAM + '"]').forEach(function (other) {
      if (other !== target && other.checked) other.checked = false;
    });
  }

  // capture: facet-filters-form の submit ハンドラ(bubble)より先に走らせる
  document.addEventListener('change', onChange, true);
})();
